

















































import Vue from 'vue';
// not going to refactor and type the VueSelect
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueSelect from 'vue-select';
import config from '../../../../config';
import 'vue-select/dist/vue-select.css';
import FetchHelper from '../../../helpers/OldFetchHelper';
import LocalStorageHelper from '../../../helpers/OldLocalStorageHelper';
import PartnerShopMethods from '../../../methods/PartnerShopMethods';
import { IPartnerSearchResult } from '../../../common/interfaces/partners.interface';
import { IOldCustomSelectOption } from '../../../common/interfaces/shared.interface';

interface IPartnerSelectComponent {
  OpenIndicator: { render: (arg: (el: string, options: { class: string }) => HTMLElement) => unknown };
  isPartnerShop: boolean;
  options: unknown[];
  value: unknown;
}

interface IPartnerSelectRefs {
  vueSelect: typeof VueSelect & { clearSelection: () => unknown };
}

export default Vue.extend({
  components: {
    'v-select': VueSelect,
  },
  data(): IPartnerSelectComponent & { $refs?: IPartnerSelectRefs } {
    return {
      OpenIndicator: {
        render: (createElement): HTMLElement => createElement(`span`, { class: `partner-select__icon` }),
      },
      isPartnerShop: false,
      options: [],
      value: ``,
    };
  },
  props: {
    mentorData: {
      default: null,
      type: Object as () => unknown,
    },
    placeholder: {
      default: ``,
      type: String,
    },
    searchPlaceholder: {
      default: ``,
      type: String,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    taggable: {
      default: true,
      type: Boolean,
    },
    testSelector: {
      default: ``,
      type: String,
    },
  },
  async mounted(): Promise<void> {
    await this.checkForPartnerShop();
    if(this.isPartnerShop) await this.setUpPartnerData();
  },
  methods: {
    ...PartnerShopMethods,
    clear(): void {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      this.$refs.vueSelect.clearSelection();
    },
    onSearch(search: string, loading: (state: boolean) => void) {
      loading(true);
      this.search(loading, search, this);
    },
    // i have seriously no idea how to make this work, any input is appreciated
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    search: window._.debounce(async (loading: (state: boolean) => void, searchString: string, vm: any) => {
      if(!searchString || searchString.length < 3) {
        loading(false);
        return;
      }
      const response = await FetchHelper.post({ body: { searchString }, path: `/partners/search` });
      if(response.success) {
        // eslint-disable-next-line no-param-reassign
        vm.options = response.data.map((r: IPartnerSearchResult): IOldCustomSelectOption => { return { ...r, code: r.partnerId, label: `${r.company ? r.company : `${r.firstName} ${r.lastName}`}- ${r.zipCode} ${r.city}` }; });

        /* exactly one result was found and the user entered only digits
         * really high chance he wanted to find a partner by partner number so blur and refocus the input field
         * input value is lost in the process, the user is forced to click on the found partner, ensures correct storing and linking in database
         */
        if(response.data.length === 1 && /^\d*$/.test(searchString)) {
          vm.$refs.searchInputField.blur();
          vm.$refs.searchInputField.focus();
        }
      }
      loading(false);
    }, 750),
    async setUpPartnerData(): Promise<void> {
      const partnerData = LocalStorageHelper.getPartnerShopInformation();
      if(partnerData) {
        const fetchConfig = {
          body: {
            searchString: partnerData.customerNumber.toString(),
          },
          path: `${config.api.paths.partnershop.basepath}${config.api.paths.partnershop.paths.search}`,
        };
        const fetchResult = await FetchHelper.post(fetchConfig);
        if(fetchResult.success) {
          const r = fetchResult.data[0];
          this.value = { ...r, code: r.partnerId, label: `${r.firstName} ${r.lastName} - ${r.zipCode} ${r.city}` };
          this.$emit(`input`, this.value);
        } else {
          console.info(`partner not found`); // is this even possible?
        }
      } else {
        await this.getPartnerShopInformation();
        await this.setUpPartnerData();
      }
    },
  },
  watch: {
    mentorData(): void {
      this.value = this.mentorData;
    },
  },
});
